export class SingletonList {
    constructor() {
        this.elements = [];
        this.length = 0;
    }
    add(element) {
        let index = this.elements.indexOf(element);
        if (index != -1 && index < this.length)
            return;
        if (this.length === this.elements.length)
            this.elements.push(element);
        else
            this.elements[this.length] = element;
        this.length++;
    }
    addList(list) {
        let len = this.length;
        let len2 = list.length;
        this.length = len + len2;
        if (this.elements.length < this.length)
            this.elements.length = this.length;
        for (let i = 0; i < len2; i++) {
            this.elements[len + i] = list.elements[i];
        }
    }
    indexof(element) {
        let index = this.elements.indexOf(element);
        if (index != -1 && index < this.length)
            return index;
        return -1;
    }
    remove(element) {
        let index = this.elements.indexOf(element);
        if (index != -1 && index < this.length) {
            this.elements[index] = this.elements[this.length - 1];
            this.elements[this.length - 1] = null;
            this.length--;
        }
    }
    clear() {
        this.elements = [];
        this.length = 0;
    }
    clean() {
        this.elements.length = this.length;
    }
    cloneTo(out) {
        out.length = this.length;
        out.elements = this.elements.slice();
    }
    destroy() {
        this.elements = null;
    }
}
export class FastSinglelist extends SingletonList {
    add(element) {
        if (this.length === this.elements.length)
            this.elements.push(element);
        else
            this.elements[this.length] = element;
        this.length++;
    }
}
